import { I } from "../../components/icons";
import { NavRow, RowGroup } from "../../components/Rows";
import { Segmented } from "../../components/Segmented";
import { TEXT_SIZES } from "../../lib/textSize";
import type { TextSize } from "../../storage/local";
import { useKaya } from "../../store/kayaStore";
import SettingsPage from "./SettingsPage";

/**
 * You › Display: the text size on this phone (kit §40, board YouDisplay).
 *
 * Applied the moment it is pressed, with no Save: the page itself is the preview, so the answer
 * is visible before the thumb has left the button. Kept in `LocalMeta`, never synced, so a
 * parent's phone can read Larger while the owner's stays Normal on the same account.
 */
export default function DisplaySettings() {
  const size = useKaya((s) => s.meta.textSize ?? "normal");
  const setTextSize = useKaya((s) => s.setTextSize);

  return (
    <SettingsPage title="Display">
      <section className="k-group">
        <h2 className="k-group__h">Text size</h2>
        <div className="you-stack">
          <Segmented<TextSize> ariaLabel="Text size" value={size} options={TEXT_SIZES} onChange={setTextSize} />
          <p className="k-field__hint">This phone only — your other phones keep their own size.</p>
        </div>
      </section>

      <RowGroup heading="What changes">
        <NavRow
          kind="value"
          icon={I.tick}
          title="Words and figures grow"
          subtitle="Buttons and rows grow with them, so nothing is cut off"
        />
        <NavRow
          kind="value"
          icon={I.tick}
          title="The tab bar keeps five tabs"
          subtitle="Its labels grow a little less, so Progress still fits"
        />
        <NavRow
          kind="value"
          icon={I.tick}
          title="The workout clock stays"
          subtitle="It is already the largest thing on screen; only the move name and labels grow"
        />
      </RowGroup>
    </SettingsPage>
  );
}
